import axios from 'axios'

export default axios.create({
    baseURL: 'https://www.dataoceantech.cn/v1',
    timeout: 10000
})



// WEBPACK FOOTER //
// ./src/api/index.js